/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";
import { PaymentDetailsBorder } from "../paymentDetailsBorder/PaymentDetailsBorder";
import { observer } from "mobx-react-lite";
import { usePaymentStore } from "../../stores/StoreContext";
import { formatAmount } from "../../utils/utils";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import "./PaymentDetails.css";
import { PaymentDescriptionOld } from "../paymentDescription/PaymentDescriptionOld";

type props = {};

export const PaymentDetailsOld: React.FC<props> = observer(() => {
  const paymentStore = usePaymentStore();

  const remainingAmount =
    paymentStore.totalAmount - paymentStore.payMyPartAmount;

  return (
    <div
      style={{
        backgroundColor: Colors.greenBg,
        paddingTop: 32,
        paddingLeft: 20,
        paddingRight: 20,
        borderRadius: 20,
        marginTop: 20,
      }}>
      {paymentStore.isPlayerPricesListLoading ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <LoadingSpinner loading className="custom-spinner-color" />
        </div>
      ) : (
        <div>
          <TCText
            style={{
              fontWeight: 700,
              fontSize: 32,
              lineHeight: 1.1,
              color: Colors.green,
              textAlign: "center",
            }}
            value={`${formatAmount(paymentStore.payMyPartAmount)} USD`}
          />
          <TCText
            style={{
              fontWeight: 500,
              fontSize: 14,
              color: Colors.green,
              textAlign: "center",
            }}
            value={"Pay your Part"}
          />
        </div>
      )}
      {/* <TCText
        style={{
          fontWeight: 600,
          fontSize: 14,
          color: Colors.green,
          textAlign: "center",
          marginTop: 10,
          marginBottom: 30,
        }}
        value="Price details"
      />
      <PaymentDetailsBorder />
      <div style={{ height: 20 }} /> */}
      <PaymentDescriptionOld />
      {remainingAmount > 0 ? (
        <TCText
          style={{
            fontSize: 10,
            color: Colors.green,
            marginTop: 15,
            marginBottom: 10,
          }}
          value={`If other players do not pay, you will be charged additional ${formatAmount(
            remainingAmount
          )} USD`}
        />
      ) : (
        <div style={{ height: 15 }} />
      )}
    </div>
  );
});
